import Cookies from 'js-cookie'

const TokenKey = 'vue_token'

export function getToken() {
	// return "66666"
	// return "17efee542488f2cccc638c878547d345baf3b093b7b5eae68ae1a5ca0718a8a8"
	return Cookies.get(TokenKey)
}

export function setToken(token) {
	// 设置了过期时间
	return Cookies.set(TokenKey, token, {
		expires: 365
	})
}

export function removeToken() {
	return Cookies.remove(TokenKey)
}

// const UidKey = 'uid'
// export function getUid() {
// 	return Cookies.get(UidKey)
// }

// export function setUid(uid) {
// 	// 设置了过期时间
// 	return Cookies.set(UidKey, uid, {
// 		expires: 365
// 	})
// }